export default "__VITE_ASSET__ace7e59f__"